import { Info } from 'lucide-react';

interface Props {
  noun: 'badge' | 'certificate';
}

export const RevokedCredentialBanner = ({ noun }: Props) => (
  <div
    role="alert"
    className="flex items-center gap-6 rounded-lg border border-border-error bg-destructive-soft px-5 py-2"
  >
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p className="font-medium text-destructive">
        {noun === 'badge' ? 'Badge' : 'Certificate'} has been revoked
      </p>
      <p className="text-sm text-tertiary">
        This {noun} is no longer valid and should not be considered reliable.
      </p>
    </div>
    <Info className="h-6 w-6 shrink-0 text-destructive" />
  </div>
);
